import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";

import * as service from "../services/userService";
import * as utils from "../utils/utilities";

const slice = createSlice({
  name: "users",
  initialState: {
    loading: false,
    error: false,
    lastUpdated: null,
    users: [],
    supervisors: [],
  },
  reducers: {
    usersRequested: (state, action) => {
      state.loading = true;
    },
    usersRequestSuccess: (state, action) => {
      state.users = action.payload;
      state.loading = false;
      state.error = false;
    },
    supervisorsRequestSuccess: (state, action) => {
      state.supervisors = action.payload;
    },
    usersRequestFailed: (state, action) => {
      state.loading = false;
      state.error = true;
    },
    updateSyncTime: (state, action) => {
      state.lastUpdated = Date.now();
    },
  },
});

export const loadUsers = () => async (dispatch, getState) => {
  try {
    dispatch(slice.actions.usersRequested());

    const userResult = await service.getAllUsers();
    const supervisorResult = await service.getSupervisors();

    dispatch(slice.actions.supervisorsRequestSuccess(supervisorResult.data));
    dispatch(slice.actions.usersRequestSuccess(userResult.data));
    dispatch(slice.actions.updateSyncTime());
  } catch (ex) {
    const cachedUsers = utils.getCachedDataFromException(ex);
    if (!cachedUsers) return dispatch(slice.actions.usersRequestFailed());

    dispatch(slice.actions.usersRequestSuccess(cachedUsers));
  }
};

export const getUsers = createSelector(
  (state) => state,
  (state) => state.users
);

export default slice.reducer;
